import React from "react";
import DatePicker, { CalendarContainer } from "react-datepicker";
import { withTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../../shared/datePickerDialog/datePickerDialog.scss";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../../shared/checkBox/CheckBox.module.scss";
import UiDateUtils from "../../../../../utils/UiDateUtils";
import {
  TRANSLATED_DAYS,
  TRANSLATED_MONTHS,
} from "../../../../../common/Constants";

class PaymentCalendarDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      effectiveDate: this.formatTodayDate(),
    };
    this.ref = React.createRef();
    this.days = TRANSLATED_DAYS.map((days) => this.props.t(days.label));
    this.months = TRANSLATED_MONTHS.map((months) => this.props.t(months.label));
    this.locale = {
      localize: {
        day: (n) => this.days[n],
        month: (n) => this.months[n],
      },
      formatLong: {},
    };
  }

  formatTodayDate = () => {
    const dateString = this.props.todayDate;
    const year = dateString.substring(0, 4);
    const month = dateString.substring(5, 7);
    const day = dateString.substring(8, 10);
    return new Date(year, month - 1, day);
  };

  selectEffectiveDate = (date) => {
    if (date !== null) {
      this.setState({ effectiveDate: date });
    }
  };

  closeCalenderDialog = () => {
    this.ref.current.setOpen(false);
  };

  changeApplicationStatus = () => {
    this.ref.current.setOpen(true);
  };

  confirmCalendarDialog = () => {
    this.closeCalenderDialog();
    const year = this.state.effectiveDate.getFullYear();
    const month = this.state.effectiveDate.getMonth() + 1;
    const day = this.state.effectiveDate.getDate();

    const date = UiDateUtils.formatDateYYYYMMDD(year, month, day);
    this.props.confirmDialog(date);
  };

  render() {
    const MyContainer = ({ children }) => {
      return (
        <div className="dialogContainer">
          <CalendarContainer>
            <div className="dialogTitleLight">
              {this.props.t("PaymentMethod.agreed")}
            </div>
            <div className="calendarContainer"> {children}</div>
          </CalendarContainer>
        </div>
      );
    };

    const CheckBoxInput = () => (
      <CheckBox
        id="finance_application_id"
        checked={false}
        isDisabled={!this.props.canConvert}
        label={this.props.label}
        onChange={(e) => this.changeApplicationStatus(e)}
        textClass={checkboxStyles.boldLabel}
      />
    );

    const formatMaxDate = () => {
      const todayDate = this.props.todayDate.split("-");
      return new Date(todayDate[0], todayDate[1] - 1, todayDate[2]);
    };

    return (
      <div className="datePickerDialogStyles">
        <DatePicker
          ref={this.ref}
          locale={this.locale}
          selected={this.state.effectiveDate}
          withPortal
          shouldCloseOnSelect={false}
          onChange={this.selectEffectiveDate}
          maxDate={formatMaxDate()}
          calendarContainer={MyContainer}
          customInput={<CheckBoxInput />}
        >
          <div className="buttonsDiv">
            <div className="setButtons" onClick={this.closeCalenderDialog}>
              <CancelOutlinedIcon style={{ color: "rgb(224, 114, 110)" }} />
              <span data-testid="cancelCalendarBtn" className="buttonText">
                {this.props.t("CustomerOrderDetails.cancel")}
              </span>
            </div>
            <div className="setButtons" onClick={this.confirmCalendarDialog}>
              <CheckCircleOutlineOutlinedIcon
                style={{ color: "rgb(16, 43, 78)" }}
              />
              <span data-testid="confirmCalendarBtn" className="buttonText">
                {this.props.t("CustomerOrderDetails.save")}
              </span>
            </div>
          </div>
        </DatePicker>
      </div>
    );
  }
}

export default withTranslation("emp")(PaymentCalendarDialog);
